<template>
  <Toast unstyled class="custom-toast">
    <template #container="{ message, closeCallback }">
      <div :class="{
        container: true,
        [message.severity]: true,
      }">
        <div class="summary">{{ message.summary }}</div>
        <div class="close-button" @click="closeCallback"><i class="pi pi-times-circle text-xl" /></div>
        <div class="detail">{{ message.detail }}</div>

      </div>
    </template>
    <!--    <template #message="slotProps">-->
    <!--      <div>-->
    <!--        <span class="">{{ slotProps.message.summary }}</span>-->
    <!--        <div class="">{{ slotProps.message.detail }}</div>-->
    <!--      </div>-->
    <!--    </template>-->
  </Toast>
</template>

<style scoped lang="scss">
.custom-toast {
  .container {
    @apply shadow-lg mb-2 py-2 px-3 rounded-lg grid grid-cols-2 gap-2;
    grid-template-columns: 1fr min-content;
  }
  .error { @apply bg-red-500 }
  .secondary { @apply bg-slate-500 }
  .info { @apply bg-cyan-500 }
  .success { @apply bg-emerald-500 }
  .warn { @apply bg-yellow-600 }
  .contrast { @apply bg-gray-800 }

  .close-button { @apply cursor-pointer }
  .summary { @apply font-bold pt-1 }
  .detail { @apply text-sm }
}
</style>
<script setup lang="ts">
</script>
